var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 199,
    viewBox: "0 0 198 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 199,
    fill: "#D2D2D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3576_41652)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1005,
    transform: "translate(-1190 -305)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3576_41652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198 0.378906H0V198.379H198V0.378906Z",
    fill: "#D4E6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.53 119.157C112.075 124.921 112.691 139.082 114.239 161.317H84.0767C85.1327 144.853 86.2033 126.652 85.7853 119.157H112.53Z",
    fill: "#F9DFA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.53 119.157C112.369 126.527 112.376 131.954 112.941 140.439C102.432 138.429 92.7007 131.499 85.7927 123.029V119.157H112.537H112.53Z",
    fill: "#EACE95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.342 79.1609C133.342 95.5583 111.767 129.218 99.1467 129.218C86.526 129.218 64.9513 97.5089 64.9513 79.1609C64.9513 56.8969 80.2633 38.8496 99.1467 38.8496C118.03 38.8496 133.342 56.8969 133.342 79.1609Z",
    fill: "#FFE8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.941 165.423H85.382V134.953C85.4114 144.633 112.882 144.259 112.941 134.953V165.423Z",
    fill: "#75A29C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.959 198.378H45.034C45.034 198.378 47.6447 161.052 51.0253 156.344C56.8847 148.226 75.8267 141.941 85.3307 139.785C85.4553 148.013 92.2973 152.134 99.1467 152.142H99.1613C106.003 152.142 112.86 148.02 112.977 139.785C112.977 139.785 139.92 147.507 147.151 157.554C150.531 162.262 152.959 198.378 152.959 198.378Z",
    fill: "#56626B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.959 198.378H99.1467V152.142H99.1613C106.003 152.142 112.86 148.02 112.977 139.785C112.977 139.785 139.92 147.507 147.151 157.554C150.531 162.262 152.959 198.378 152.959 198.378Z",
    fill: "#525D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.382 134.945C88.6307 139.785 90.9113 141.846 99.1467 142.066L91.0947 152.751C84.876 161.008 83.3507 148.637 83.6587 143.379C83.9153 138.993 85.3747 134.945 85.3747 134.945H85.382Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.911 134.945C109.663 139.785 107.382 141.846 99.1467 142.066L107.199 152.751C113.417 161.008 114.943 148.637 114.635 143.379C114.378 138.993 112.919 134.945 112.919 134.945H112.911Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6113 85.6586C76.8093 91.8332 73.3847 96.9519 68.9553 97.0986C64.526 97.2379 60.918 89.6919 60.72 83.5172C60.522 77.3426 63.8 74.8859 68.2293 74.7392C72.6587 74.5999 76.4133 79.4839 76.6113 85.6586Z",
    fill: "#FFE8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.689 85.6586C121.491 91.8332 124.916 96.9519 129.345 97.0986C133.775 97.2379 137.383 89.6919 137.581 83.5172C137.779 77.3426 134.501 74.8859 130.071 74.7392C125.642 74.5999 121.887 79.4839 121.689 85.6586Z",
    fill: "#FFE8B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.342 79.1609C133.342 95.5583 111.767 129.218 99.1467 129.218V38.8496C118.03 38.8496 133.342 56.8969 133.342 79.1609Z",
    fill: "#F9DFA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.539 54.1469C140.074 54.4329 140.617 54.7189 141.152 55.0049C141.269 51.6682 140.191 48.3022 138.153 45.6622C138.615 45.8822 139.077 46.1096 139.546 46.3296C138.864 42.7656 136.305 39.6122 132.953 38.2189C133.613 38.2189 134.273 38.2116 134.933 38.2042C132.249 35.9602 128.817 34.6622 125.327 34.4936C124.036 34.2809 122.745 34.3176 121.513 34.6916C120.641 30.9516 117.744 28.3556 114.151 26.5589C108.629 22.0123 101.933 18.8882 94.886 17.6562C96.734 17.8469 98.3253 19.4969 98.4427 21.3523C92.136 19.4236 85.1107 19.9369 79.156 22.7603C80.1973 23.1782 81.2387 23.5963 82.28 24.0069C74.734 23.5083 67.034 27.1749 62.6707 33.3496C64.2693 32.7702 65.868 32.1982 67.4593 31.6189C59.906 35.5862 54.582 43.5136 53.7753 52.0056C55.1907 50.7442 56.6133 49.4829 58.0287 48.2216C54.516 55.1296 53.636 63.3282 55.5867 70.8302C56.144 69.4222 56.7013 68.0069 57.2587 66.5989C56.4667 70.4269 60.2653 73.0522 62.5973 77.0709L63.2207 76.5649C63.844 76.1102 64.8487 75.4869 65.8753 75.3622C67.5327 75.1569 68.046 88.2029 68.046 88.2029H69.9673C69.9673 88.2029 70.73 81.7056 72.4533 77.1222C72.4533 77.1222 73.37 75.8316 73.876 74.1596C79.266 74.2842 86.6507 73.3896 91.322 71.7396C90.332 72.5242 89.342 73.3089 88.352 74.0936C94.7247 73.4702 100.811 70.3389 105.021 65.5209C104.61 66.5916 104.199 67.6696 103.781 68.7402C109.523 64.0176 114.393 58.2536 118.118 51.8296C118.888 51.5069 119.607 51.4336 120.267 51.6902C121.682 59.7789 123.383 66.1882 126.17 70.0529C127.952 72.5242 127.123 77.1222 127.123 77.1222C128.839 81.7056 129.609 88.2029 129.609 88.2029H131.531C131.531 88.2029 131.809 75.2302 133.467 75.4282C135.124 75.6336 136.561 77.8482 136.561 77.8482C136.561 77.8482 137.053 75.9636 137.639 73.0156C139.047 69.8916 139.759 66.4596 139.663 63.0349C140.118 63.7242 140.565 64.4136 141.02 65.1102C141.717 61.4216 141.189 57.5202 139.546 54.1469H139.539Z",
    fill: "#544D48"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3576_41652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1005,
    fill: "white",
    transform: "translate(-1190 -305)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3576_41652"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.378906,
    width: 198,
    height: 198,
    rx: 99,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingMan);
export default __webpack_public_path__ + "static/media/onboarding-man.653c9e16aa5d7da4a02f2ccabed329ce.svg";
export { ForwardRef as ReactComponent };